<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">REVENUE REPORTS DASHBOARD</h4>
      <div class="title-decoration"></div>
    </v-card-title>
    
    <v-layout row wrap class="filter-section">
      <v-flex lg3 md3 sm12 xs12>
        <v-container>
          <v-dialog
            ref="dialog"
            persistent
            v-model="modal1"
            lazy
            full-width
            width="290px"
            :return-value.sync="revenue_date.start_date"
          >
            <v-text-field
              slot="activator"
              label="Start Date"
              v-model="revenue_date.start_date"
              readonly
              class="futuristic-input"
              prepend-icon="event"
            ></v-text-field>
            <v-date-picker v-model="revenue_date.start_date" scrollable class="futuristic-datepicker">
              <v-spacer></v-spacer>
              <v-btn
                depressed
                flat
                color="primary"
                @click="modal1 = false"
                class="futuristic-btn-secondary"
                >Cancel</v-btn
              >
              <v-btn
                depressed
                flat
                color="primary"
                @click="$refs.dialog.save(revenue_date.start_date)"
                class="futuristic-btn"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-container>
      </v-flex>
      <v-flex lg3 md3 sm12 xs12>
        <v-container>
          <v-dialog
            ref="dialog1"
            persistent
            v-model="modal2"
            lazy
            full-width
            width="290px"
            :return-value.sync="revenue_date.end_date"
          >
            <v-text-field
              slot="activator"
              label="End Date"
              v-model="revenue_date.end_date"
              readonly
              class="futuristic-input"
              prepend-icon="event"
            ></v-text-field>
            <v-date-picker
              :min="revenue_date.start_date"
              v-model="revenue_date.end_date"
              scrollable
              class="futuristic-datepicker"
            >
              <v-spacer></v-spacer>
              <v-btn
                depressed
                flat
                color="primary"
                @click="modal2 = false"
                class="futuristic-btn-secondary"
                >Cancel</v-btn
              >
              <v-btn
                depressed
                flat
                color="primary"
                @click="$refs.dialog1.save(revenue_date.end_date)"
                class="futuristic-btn"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-container>
      </v-flex>
      <v-flex lg3 md3 sm12 xs12>
        <v-container>
          <v-select
            label="Select Report Type"
            v-model="revenue_date.report_item"
            :items="allReports"
            @change="getData()"
            required
            item-text="value"
            item-value="id"
            :loading="$loadingTrue"
            class="futuristic-select"
            prepend-icon="assessment"
          ></v-select>
        </v-container>
      </v-flex>
      <v-flex lg3 md3 sm12 xs12>
        <v-container class="btn-container">
          <v-btn
            depressed
            color="#587e27"
            @click="getData()"
            block
            :loading="this.$store.state.LoadingStore.loading"
            class="futuristic-btn"
          >
            <v-icon left>refresh</v-icon>
            Generate Report
          </v-btn>
        </v-container>
      </v-flex>
    </v-layout>

    <v-container class="report-container">
      <TransactionReport
        v-if="revenue_date.report_item === '1'"
      ></TransactionReport>
      <BookingsRevenueReport
        v-if="revenue_date.report_item === '2'"
      ></BookingsRevenueReport>
      <EntranceFeeRevenueReport
        v-if="revenue_date.report_item === '3'"
      ></EntranceFeeRevenueReport>
      <VehicleReport v-if="revenue_date.report_item === '4'"></VehicleReport>
      <InventoryRevenueReport
        v-if="revenue_date.report_item === '5'"
      ></InventoryRevenueReport>
      <facility-chart v-if="revenue_date.report_item === '5'"></facility-chart>
    </v-container>
  </v-card>
</template>

<script>
import BookingsRevenueReport from "./charts/BookingsRevenueReport";
import EntranceFeeRevenueReport from "./charts/EntranceFeeRevenueReport";
import VehicleReport from "./charts/VehicleReport";
import InventoryRevenueReport from "./charts/InventoryRevenueReport";
import TransactionReport from "./charts/TransactionReport";

export default {
  components: {
    BookingsRevenueReport,
    EntranceFeeRevenueReport,
    VehicleReport,
    InventoryRevenueReport,
    TransactionReport,
  },
  data() {
    return {
      revenue_date: {
        start_date: this.$moment(this.today).format("YYYY-MM-DD"),
        end_date: this.$moment(this.today).format("YYYY-MM-DD"),
        currency: this.$store.state.CurrencyStore.browser_currency_id,
        report_item: "1",
      },
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      loading: true,
      today: this.$moment.now(),
    };
  },
  computed: {
    allReports: function () {
      let reportItems = [
        { id: "1", value: "Transactions Report" },
        // { id: "2", value: "Bookings Revenue Report" },
        { id: "3", value: "Entrance Fee Revenue" },
        { id: "4", value: "Motor Vehicle Revenue" },
        { id: "5", value: "Activity Revenue" },
        // { id: "6", value: "Facility Revenue" },
      ];
      return reportItems;
    },
  },
  methods: {
    getData() {
      if (this.revenue_date.report_item == "1") {
        this.$store.dispatch("get_transactions_chart", this.revenue_date);
      } else if (this.revenue_date.report_item == "2") {
        this.$store.dispatch("get_bookings_revenue_chart", this.revenue_date);
      } else if (this.revenue_date.report_item == "3") {
        this.$store.dispatch("get_residency_revenue_chart", this.revenue_date);
      } else if (this.revenue_date.report_item == "4") {
        this.$store.dispatch("get_vehicle_revenue_chart", this.revenue_date);
      } else if (this.revenue_date.report_item == "5") {
        this.$store.dispatch("get_inventory_revenue_chart", this.revenue_date);
      }
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.filter-section {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 16px;
}

.report-container {
  padding: 16px 0;
}

.futuristic-input >>> .v-input__slot,
.futuristic-select >>> .v-input__slot {
  background: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.futuristic-input >>> .v-text-field__slot input,
.futuristic-select >>> .v-select__selection {
  color: #587e27;
  font-weight: 500;
}

.futuristic-datepicker {
  border-radius: 8px;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  color: white;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(46, 125, 50, 0.3);
}

.futuristic-btn-secondary {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-container {
  display: flex;
  align-items: center;
  height: 100%;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .filter-section {
    margin: 12px;
    padding: 12px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .filter-section {
    margin: 8px;
    padding: 8px;
  }
  
  .btn-container {
    padding-top: 0;
  }
}
</style>